import React from 'react'
import Stack from '@mui/material/Stack'
import SectionForm from '../../../common/sectionForm'
import PhoneComponent from '../../../common/phoneComponent'
import useMediaQuery from '@mui/material/useMediaQuery'

interface Props {
  formik: any
}

const MainPhoneForm = ({ formik }: Props) => {
  const isMobile = useMediaQuery('(max-width:800px)')

  return (
    <SectionForm title='Téléphone principal'>
      <Stack direction={isMobile ? 'column' : 'row'} spacing='24px'>
        <PhoneComponent
          object={formik.values.mainPhone}
          typeName='mainPhone.type'
          phoneName='mainPhone.phone_number'
          postName='mainPhone.phone_number_post'
          required
        />
      </Stack>
    </SectionForm>
  )
}

export default MainPhoneForm
